import React from 'react';
import { inject, observer } from 'mobx-react';
import { injectIntl } from 'react-intl';
import Profile from '../Profile';
import { Modal, Button } from 'react-bootstrap';

@injectIntl
@inject('membersStore')
@observer
export default class ProfileModal extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.handleClose = this.handleClose.bind(this);

    this.state = {
      show: false,
      profileProps: null
    };
  }

  handleClose() {
    this.props.membersStore.toggleShowModal();
  }

  render() {
    const { membersStore, intl } = this.props;

    return (
      <Modal
        className="react-board note-modal-container"
        bsSize="large"
        show={membersStore.showProfileModal}
        onHide={this.handleClose}
      >
        <Modal.Header>
          <div className="centered">
            {membersStore.isProfileLoading ||
            !membersStore.showProfileModal ? null : (
              <React.Fragment>
                <img
                  className="note-creator-photo"
                  src={membersStore.profileMember.user.profile_photo_url}
                />
                <br />
                <span>{membersStore.profileMember.user.name}</span>{' '}
              </React.Fragment>
            )}
          </div>
        </Modal.Header>
        <Modal.Body
          style={{ maxHeight: '60vh' }}
          className="note-modal-body-container gray-background"
        >
          {membersStore.isProfileLoading ? (
            <div className="loader-lg" />
          ) : (
            <Profile {...membersStore.currentProfileData} />
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button bsStyle="primary" onClick={this.handleClose}>
            {intl.formatMessage({ id: 'close' })}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}
